import React, { useState, useEffect } from 'react';
import { map, get } from 'lodash';
import { verifiableCompanyName } from 'libs/api/user';
import { CEmail } from 'constants/base.const';
import { Modal, Button, Typography } from 'antd';
import { PrimaryColor, SecondaryColor } from 'GlobalStyles';

const { Title } = Typography;
type TVerificationCompanyModalProps = {
  visible: boolean;
  setVisible: any;
};
const VerificationCompanyModal = ({ visible, setVisible }: TVerificationCompanyModalProps) => {
  // const [{data, loading}] = useDataApi<{value: string}>(verifiableCompanyName.bind(null));
  const [companies, setCompanies] = useState<Array<{ value: string }>>();

  const getMentoringCompanies = async () => {
    const { data } = await verifiableCompanyName({ sign_up: 'sign_up' });

    if (data) {
      setCompanies(data);
    }
  };

  function handleCancel() {
    setVisible(false);
  }

  useEffect(() => {
    getMentoringCompanies();
  }, []);

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={false}
      footer={
        <Button style={{ width: '100%' }} onClick={handleCancel}>
          확인
        </Button>
      }
      width={360}
      onCancel={handleCancel}
    >
      <div style={{ textAlign: 'center' }}>
        <Title level={3}>현재 인증 가능한 회사 목록</Title>
      </div>
      <div style={{ fontSize: '13px', color: `${PrimaryColor}` }}>
        {map(companies, (v) => (
          <span>
            • {get(v, 'value')}
            <br />
          </span>
        ))}
      </div>
      <div
        style={{
          marginTop: '10px',
          fontSize: '12px',
          color: `${SecondaryColor}`,
        }}
      >
        • 인증 가능한 회사 목록에 없을 시, Career Step으로 업데이트 요청 메일 부탁 드립니다. 검토 후
        업데이트하겠습니다. ({CEmail})
      </div>
    </Modal>
  );
};

VerificationCompanyModal.defaultProps = {};

export default VerificationCompanyModal;
